// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"52bba4ad","613":"dd1c8114"}[chunkId] + ".chunk.css";
};